module.exports = __webpack_public_path__ + "static/img/physicalwork.3b94020e.png";